import {Component} from "react";
import {Button, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup} from "@material-ui/core";
import i18n from "../i18n";
import styles from './LanguageSelector.module.scss';
import Typography from "@material-ui/core/Typography";
import {ModalComponentService} from "../common/ModalComponentService";
import {LocaleService} from "../common/LocaleService";
import type { Language } from "../common/LocaleService";
import type { ModalChildProps } from './ModalComponent';

interface LanguageSelectorState {
    language: Language;
}

export default class LanguageSelector extends Component<ModalChildProps, LanguageSelectorState> {
    constructor(props: ModalChildProps) {
        super(props);

        this.state = {
            language: LocaleService.getLanguage(),
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount(): void {
        // needed to remove the aria-hidden error on render
        (document.activeElement as HTMLElement).blur();
    }

    handleChange(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({language: event.target.value as Language});
    }

    handleClick(): void {
        LocaleService.setLanguage(this.state.language);
        ModalComponentService.reset();
    }

    render() {
        return (
            <div className={styles.languageSelector} >
                <FormLabel id="demo-radio-buttons-group-label">
                    <Typography variant="h5" component="h5">
                        { i18n.t('menu.language') }
                    </Typography>
                </FormLabel>
                <FormControl className={styles.radioGroup}>
                    <RadioGroup
                        name="radio-buttons-group"
                        onChange={this.handleChange}
                        value={this.state.language}
                    >
                        <FormControlLabel
                            value="es"
                            control={<Radio />}
                            label="Español"
                        />
                        <FormControlLabel value="en" control={<Radio />} label="English" />
                    </RadioGroup>
                </FormControl>

                <div className={styles.buttonsContainer}>
                    <Button
                        className={styles.button}
                        variant="contained"
                        color="primary"
                        onClick={this.handleClick}
                    >{ i18n.t('dialog.accept') }</Button>
                </div>
            </div>
        )
    }
}